import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";

export function useScheduledPosts(query?: Record<string, string | number | undefined>) {
  return useQuery({
    queryKey: ["scheduled-posts", query],
    queryFn: () => api.listScheduledPosts(query),
    staleTime: 30_000,
  });
}

export function useCreateScheduledPost() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.createScheduledPost,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["scheduled-posts"] });
      toast.success("Publicación programada");
    },
  });
}

export function useCancelScheduledPost() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.cancelScheduledPost,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["scheduled-posts"] });
      toast.success("Publicación cancelada");
    },
  });
}
